import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=66c3ae3b&scoped=true"
import script from "./distributor.vue?vue&type=script&lang=js"
export * from "./distributor.vue?vue&type=script&lang=js"
import style0 from "./distributor.vue?vue&type=style&index=0&id=66c3ae3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3ae3b",
  null
  
)

export default component.exports